/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part Arabic transition words to be used by the assessments.
 * @returns {Array}                     The array filled with two-part transition words.
 */
export default function() {
	return [ [ "لا", "ولا" ], [ "إما", "أو" ], [ "ربما", "ربما" ], [ "حينئذ", "عندئذ" ], [ "إما", "وإما" ], [ "كل من", "و" ] ];
}
